export default [
  {
    value: '4225',
    label: '倉儲服務',
  },
  {
    value: '4722',
    label: '旅行社',
  },
  {
    value: '4812',
    label: '電話通訊設備及服務',
  },
  {
    value: '4899',
    label: '有線電視',
  },
  {
    value: '5045',
    label: '3C商品',
  },
  {
    value: '5094',
    label: '寶石/黃金/珠寶貴重物',
  },
  {
    value: '5192',
    label: '書報雜誌',
  },
  {
    value: '5261',
    label: '園藝用品',
  },
  {
    value: '5399',
    label: '一般商品買賣',
  },
  {
    value: '5422',
    label: '冷凍食品',
  },
  {
    value: '5462',
    label: '西點麵包',
  },
  {
    value: '5499',
    label: '食品名特產',
  },
  {
    value: '5699',
    label: '服飾配件',
  },
  {
    value: '5732',
    label: '電器行',
  },
  {
    value: '5812',
    label: '餐廳',
  },
  {
    value: '5941',
    label: '運動商品',
  },
  {
    value: '5946',
    label: '攝影用品',
  },
  {
    value: '5963',
    label: '直銷',
  },
  {
    value: '5977',
    label: '化妝/美容保養產品',
  },
  {
    value: '5992',
    label: '花店',
  },
  {
    value: '5995',
    label: '寵物用品',
  },
  {
    value: '7011',
    label: '飯店/民宿',
  },
  {
    value: '7261',
    label: '喪葬服務及用品',
  },
  {
    value: '7298',
    label: '美容美體服務',
  },
  {
    value: '7311',
    label: '廣告服務',
  },
  {
    value: '7372',
    label: '網路資訊服務',
  },
  {
    value: '7392',
    label: '諮詢服務',
  },
  {
    value: '7519',
    label: '休閒交通工具租借',
  },
  {
    value: '7996',
    label: '樂區/博覽會',
  },
  {
    value: '7999',
    label: '娛樂休閒服務',
  },
  {
    value: '8220',
    label: '學校',
  },
  {
    value: '8299',
    label: '補習/教學服務',
  },
  {
    value: '8398',
    label: '社會福利團體',
  },
  {
    value: '8651',
    label: '政治團體',
  },
  {
    value: '8661',
    label: '宗教團體',
  },
  {
    value: '8999',
    label: '其他專業服務',
  },
]
